import { useEffect, useRef, useState } from 'react';
import { FAB } from '@upmc/ims.component-library';
import { GetCmsObjects } from '../CMS_api';
import { DataTable } from '../../../../components/UI/MDC/DataTable/DataTable';
import CmsObjectDTRow from '../classes/CmsObjectDTRow';
import Icon from '../../../../components/UI/MDC/Icon/Icon';
import styles from './CMSIndex.module.scss';
import { Link } from 'react-router-dom';
import Base from '../../../Base/Base';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { CMS_OBJECT_TYPES } from '../../CMS_Constants';
import { nanoid } from 'nanoid';
import { DeleteCmsObject } from '../CMS_api';

const CMSIndex = () => {
	const ALL_TYPE_OPTION = 'All';
	const [CmsObjects, setCmsObjects] = useState([]);
	const [rLoading, setRLoading] = useState(true);
	const [filteredCmsObjects, setFilteredCmsObjects] = useState([]);
	const [typeFilter, setTypeFilter] = useState(ALL_TYPE_OPTION);
	const searchTermRef = useRef('');

	const headers = CmsObjectDTRow.Headers;

	useEffect(() => {
		GetCmsObjects().then(response => {
			setCmsObjects(response.data);
			setRLoading(false);
		});
	}, []);

	//Where 'Type' and 'Search' filtering is done
	useEffect(() => {
		let filterResults = CmsObjects;
		if (typeFilter !== ALL_TYPE_OPTION) {
			filterResults = filterResults.filter(
				obj => obj.ObjectType.Name === typeFilter
			);
		}

		setFilteredCmsObjects(filterResults);
	}, [CmsObjects, typeFilter]);

	function deleteHandler(baseCmsObject) {
		DeleteCmsObject(baseCmsObject).then(resp => {
			setCmsObjects(resp.data);
		});
	}

	//Type box
	const ObjectTypeFilter = () => {
		return (
			<FormControl fullWidth className={styles.filterBox}>
				<InputLabel id='object_Type_SelectDropdown'>Type</InputLabel>
				<Select
					labelId='object_Type_SelectDropdown'
					id='CMS_Object_Type_SelectDropdown'
					value={typeFilter !== null ? typeFilter : ALL_TYPE_OPTION}
					label='CMSobjectType'
					onChange={e => setTypeFilter(e.target.value)}
				>
					<MenuItem key={nanoid()} value={ALL_TYPE_OPTION}>
						{ALL_TYPE_OPTION}
					</MenuItem>
					{Object.keys(CMS_OBJECT_TYPES).map(option => {
						return (
							<MenuItem
								key={nanoid()}
								value={CMS_OBJECT_TYPES[option].name}
							>
								{CMS_OBJECT_TYPES[option].name}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		);
	};

	const filterBySeachTerm = () => {
		if (searchTermRef.current && searchTermRef.current.length > 0) {
			let filterResults = CmsObjects.filter(obj => {
				const searchValue = searchTermRef.current.toLowerCase();

				//respect type filter if applicable
				if (typeFilter !== ALL_TYPE_OPTION) {
					return (
						obj.ObjectType.Name === typeFilter &&
						((obj.ID && obj.ID.toString().includes(searchValue)) ||
							(obj.Description &&
								obj.Description.toLowerCase().includes(
									searchValue
								)) ||
							(obj.Status &&
								obj.Status.toLowerCase().includes(
									searchValue
								)) ||
							(obj.ObjectType.Name &&
								obj.ObjectType.Name.toLowerCase().includes(
									searchValue
								)) ||
							(obj.StartDate &&
								obj.StartDate.toLowerCase().includes(
									searchValue
								)) ||
							(obj.EndDate &&
								obj.EndDate.toLowerCase().includes(
									searchValue
								)))
					);
				} else {
					return (
						(obj.ID && obj.ID.toString().includes(searchValue)) ||
						(obj.Description &&
							obj.Description.toLowerCase().includes(
								searchValue
							)) ||
						(obj.Status &&
							obj.Status.toLowerCase().includes(searchValue)) ||
						(obj.ObjectType.Name &&
							obj.ObjectType.Name.toLowerCase().includes(
								searchValue
							)) ||
						(obj.StartDate &&
							obj.StartDate.toLowerCase().includes(
								searchValue
							)) ||
						(obj.EndDate &&
							obj.EndDate.toLowerCase().includes(searchValue))
					);
				}
			});
			setFilteredCmsObjects(filterResults);
		}
	};

	const handleSearch = e => {
		if (e.key === 'Enter') {
			filterBySeachTerm();
		}
	};

	const resetFilters = () => {
		//reset typeFilter to 'All'
		setTypeFilter(ALL_TYPE_OPTION);
		//reset search filter to empty string
		searchTermRef.current = '';
		setFilteredCmsObjects(CmsObjects);
	};

	const SearchFilter = () => {
		return (
			<FormControl fullWidth className={styles.filterBox}>
				<TextField
					label='Filter'
					variant='outlined'
					onKeyDown={e => handleSearch(e)}
					onChange={e => (searchTermRef.current = e.target.value)}
					autoFocus
				/>
			</FormControl>
		);
	};

	return (
		<Base loading={rLoading} title={'CMS Dashboard'} helpLink={''}>
			<div className={styles.PageContainer}>
				<div className={styles.flex_row}>
					<div className={styles.NewButton}>
						<Link
							to='/CMSManagement/new'
							style={{ textDecoration: 'none' }}
							id='link_CMSNew'
						>
							<FAB
								exited='false'
								icon={<Icon icon='add' />}
								text='New Item'
							/>
						</Link>
					</div>
					<ObjectTypeFilter />
					<SearchFilter />
					<Button
						onClick={e => filterBySeachTerm()}
						className={styles.searchButton}
						variant='contained'
						color='primary'
					>
						Search
					</Button>
					<Button
						onClick={e => resetFilters()}
						className={styles.resetButton}
						variant='contained'
						color='secondary'
					>
						Reset
					</Button>
				</div>
				<br />
				<div>
					<DataTable
						rows={CmsObjectDTRow.ConvertArray(
							filteredCmsObjects,
							deleteHandler
						)}
						headers={headers}
						className={styles.Table_Overrides}
					/>
				</div>
			</div>
		</Base>
	);
};

export default CMSIndex;
